import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f408ece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appointment_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"appointment_layout_step\" data-v-0f408ece><div class=\"appointment_step\" data-v-0f408ece><div class=\"appointment_step_item is-checked\" data-v-0f408ece>日時と場所</div><div class=\"appointment_step_item is-checked\" data-v-0f408ece>確認</div><div class=\"appointment_step_item\" data-v-0f408ece>完了</div></div></div><h1 class=\"appointment_title\" data-v-0f408ece><span class=\"appointment_title_text\" data-v-0f408ece>予約内容をご確認ください</span></h1><p class=\"appointment_text\" data-v-0f408ece> 内容がよろしければ <br data-v-0f408ece> 「面談を予約する」ボタンを押してください </p>", 3)
const _hoisted_5 = { class: "appointment_layout_confirm" }
const _hoisted_6 = { class: "appointment_confirm_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談場所", -1))
const _hoisted_8 = { class: "appointment_confirm_item_value" }
const _hoisted_9 = { class: "appointment_confirm_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談日", -1))
const _hoisted_11 = { class: "appointment_confirm_item_value" }
const _hoisted_12 = { class: "appointment_confirm_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談時間", -1))
const _hoisted_14 = { class: "appointment_confirm_item_value" }
const _hoisted_15 = { class: "appointment_confirm_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談形態", -1))
const _hoisted_17 = { class: "appointment_confirm_item_value" }
const _hoisted_18 = {
  key: 1,
  class: "appointment_button"
}
const _hoisted_19 = { class: "appointment_button" }
const _hoisted_20 = { class: "appointment_button" }

import { ref, computed, Ref } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Loading from '@/components/Loading.vue';
import alertOnReload from '@/utils/alertOnReload';
import { useRouter } from 'vue-router';
import store from '@/store';
import APPOINTMENT_PLACE from '@/constants/appointmentPlace';
import { MasterDataMainRegTypeCareer } from '@/api/masterDataEndpoint';
import { ApiError } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentconfirmView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);

const mainRegTypeId = store.getters['appointment/mainRegTypeId'];
const mainRegTypeOption: MasterDataMainRegTypeCareer[] = store.getters['appointment/mainRegTypeOption'];
const mainRegTypeLabel = mainRegTypeOption.filter((i) => Number(i.code) === Number(mainRegTypeId))[0]?.name || '';
const areaId = store.getters['appointment/areaId'];
const place = APPOINTMENT_PLACE.filter((i) => i.value === areaId)[0]?.label || '';
const jpInterviewDate = store.getters['appointment/jpInterviewDate'];
const interviewTimeLabel = store.getters['appointment/interviewTimeLabel'];

const errorMessage: Ref<string[]> = ref([]);
const errorCode: Ref<string[]> = ref([]);

// 現時刻が、既に予約している面談の「当日かつ締切時間前（月〜金9時/土日8時まで）」に該当しない場合はtrue
const hasErrorED006 = computed(() => {
  return errorCode.value.includes('ED006');
});

const save = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('appointment/reserveInterview');
    isLoading.value = false;
    transitionPage();
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: '面談予約に失敗しました', duration: null });
    errorMessage.value = (error as ApiError).response.data.errorDetail.globalError.map((i) => i.args).flat();
    errorCode.value = (error as ApiError).response.data.errorDetail.globalError.map((i) => i.code).flat();
    isLoading.value = false;
  }
};

const transitionTopPage = () => {
  router.push({ name: 'f00' });
};

const transitionPage = () => {
  router.push({ name: 'd02' });
};

const transitionPreviousPage = () => {
  router.push({ name: 'd00' });
};

const isError = computed(() => {
  return place === '' || mainRegTypeLabel === '' || jpInterviewDate === '' || interviewTimeLabel === '';
});

if (isError.value) {
  transitionPreviousPage();
}

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(place)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(jpInterviewDate)), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(interviewTimeLabel)), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(mainRegTypeLabel)), 1)
        ])
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            style: {"white-space":"pre-line"},
            errors: errorMessage.value
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true),
      (_unref(hasErrorED006))
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(BaseButton, {
              theme: "primary",
              onClick: transitionTopPage
            }, {
              default: _withCtx(() => [
                _createTextVNode("ホームへ戻る")
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(BaseButton, {
                onClick: save,
                disabled: _unref(isError) || isLoading.value || errorMessage.value.length > 0,
                theme: "primary",
                type: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 面談を予約する ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(BaseButton, {
                onClick: transitionPreviousPage,
                theme: "secondary",
                type: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修正する")
                ]),
                _: 1
              })
            ])
          ], 64))
    ])
  ]))
}
}

})